import React from 'react';

import { LicoTextField } from './LicoTextField.jsx';

export const LicoTextArea = props => <LicoTextField multiline  {...props}/>;
